__turbopack_context__.v({
  "row": "SignOffInvite-module-scss-module__WEJ0AG__row",
});
